import { localize as l } from "../../libs/Localization";

export interface IFieldHelperPasswordStrength {
	show: boolean;
	capital: boolean;
	number: boolean;
	characters: boolean;
}

const FieldHelperPasswordStrength = ({ show, capital, number, characters }: IFieldHelperPasswordStrength) => {
	const countBooleans = () => {
		let count = 0;
		if (capital) count++; // w-1/3
		if (number) count++; // w-2/3
		if (characters) count++; // w-3/3
		return count;
	}
	return (
		<div className={`${countBooleans() >= 3 ? 'hidden' : 'flex'} flex-col bg-yellow-200 mr-16 ${!show && 'hidden'}`}>
			<div className='grid grid-cols-3 sm:flex sm:flex-row h-16 place-content-center sm:place-content-evenly place-items-center'>
				<div className='col-span-2 flex flex-row place-self-start sm:place-self-auto'>
					<div
						className={`flex place-self-center mx-2 rounded-full h-2.5 w-2.5 ${capital ? 'bg-mint-400' : 'bg-gray-300'}`}
					/>
					<div className='text-xs sm:text-sm px-1'>
						<span className='font-bold'>1</span> {l['Capital letter']}
					</div>
				</div>
				<div className='col-span-2 flex flex-row place-self-start sm:place-self-auto'>
					<div
						className={`flex place-self-center mx-2 rounded-full h-2.5 w-2.5 ${number ? 'bg-mint-400' : 'bg-gray-300'}`}
					/>
					<div className='text-xs sm:text-sm px-1'>
						<span className='font-bold'>1</span> {l['Number']}
					</div>
				</div>
				<div className='col-span-2 flex flex-row place-self-start sm:place-self-auto'>
					<div
						className={`flex place-self-center mx-2 rounded-full h-2.5 w-2.5 ${characters ? 'bg-mint-400' : 'bg-gray-300'}`}
					/>
					<div className='text-xs sm:text-sm px-1'>
						<span className='font-bold'>8</span> {l['Characters']}
					</div>
				</div>
			</div>
			<div className='bg-gray-300'>
				<div className={`h-2 ${countBooleans() ? `w-${countBooleans()}/3` : 'w-0'} bg-mint-400`} />
			</div>
		</div>
	);
};

export default FieldHelperPasswordStrength